import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18.09 10.22L11.09 21.64C11.0224 21.7492 10.9283 21.8395 10.8164 21.9024C10.7045 21.9654 10.5784 21.9989 10.45 22H10.25C10.1807 21.9999 10.1121 21.9856 10.0485 21.9581C9.98492 21.9306 9.92758 21.8904 9.88001 21.84C9.83273 21.7894 9.7967 21.7294 9.77429 21.6639C9.75188 21.5984 9.74361 21.5289 9.75001 21.46L10.31 15H6.74001C6.60799 14.9986 6.47862 14.9628 6.36465 14.8962C6.25067 14.8295 6.15602 14.7343 6.09001 14.62L5.90001 14.29C5.8532 14.2132 5.82843 14.125 5.82843 14.035C5.82843 13.945 5.8532 13.8568 5.90001 13.78L12.9 2.36C12.9694 2.24792 13.0667 2.15579 13.1824 2.09268C13.2981 2.02956 13.4282 1.99762 13.56 2H13.76C13.8293 2.00013 13.8979 2.01438 13.9615 2.04189C14.0251 2.0694 14.0824 2.10959 14.13 2.16C14.1773 2.21056 14.2133 2.27057 14.2357 2.33607C14.2581 2.40157 14.2664 2.47107 14.26 2.54L13.69 9H17.26C17.392 9.00143 17.5214 9.03722 17.6354 9.10385C17.7494 9.17048 17.844 9.26566 17.91 9.38L18.1 9.71C18.1453 9.78773 18.1684 9.87644 18.1666 9.96641C18.1648 10.0564 18.1383 10.1441 18.09 10.22Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgFlash = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgFlash;
